import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";

export default function Greeting() {
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="hi-background">
        <div className="greet-main" id="greeting">
          <div className="greeting-main" >
            <div className="greeting-text-div">
              <div>
                <h1 className="greeting-text">
                  {"Hey there!"} <br />
                  {greeting.title}
                  {" "}
                </h1>
                <p className="greeting-text-p subTitle">{greeting.subTitle}</p>
                <img src="https://hitwebcounter.com/counter/counter.php?page=8071337&style=0038&nbdigits=5&type=page&initCount=0" title="Visitor Counter" Alt="web counter" border="0" style={{marginBottom:'10px'}}/>
                <SocialMedia />
                <div className="button-greeting-div">
                  <Button text="Contact me" href="#contact" />
                  <Button text="See my resume" newTab={true} href={greeting.resumeLink} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
